import Velocity from "velocity-animate";
import cash from "cash-dom";

(function (cash) {
  "use strict";

  // Show accordion content
  cash("body").on("click", ".fold-button", function () {
    let target = cash(cash(this).attr('data-target'));
    // Set active accordion
    if (!cash(this).hasClass("collapsed")) {

      Velocity(
        target,
        "slideUp",
        {
          duration: 300,
          complete: function (el) {
              let action_target = cash(cash(el).attr('data-target-by'));
            cash(el).addClass("hidden");
            action_target
              .addClass("collapsed")
              .attr("aria-expanded", false);
          },
        }
      );
    } else {
      Velocity(
        target,
        "slideDown",
        {
          duration: 300,
          complete: function (el) {
            let action_target = cash(cash(el).attr('data-target-by'));
            cash(el).removeClass("hidden");
            action_target
              .removeClass("collapsed")
              .attr("aria-expanded", true);
          },
        }
      );
    }
  });
})(cash);
